import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
let AccountCreationNotificationDialog = class AccountCreationNotificationDialog extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "toggleDialog", void 0);
    _defineProperty(this, "userFirstName", void 0);
    _defineProperty(this, "passwordUrl", void 0);
    _defineProperty(this, "visible", false);
  }
  copyPasswordUrl() {
    navigator.clipboard.writeText(this.passwordUrl);
  }
  onDialogClose() {
    this.visible = false;
    this.$emit("dialogClose");
  }
};
__decorate([Prop({
  default: false
})], AccountCreationNotificationDialog.prototype, "toggleDialog", void 0);
__decorate([Prop({
  default: ''
})], AccountCreationNotificationDialog.prototype, "userFirstName", void 0);
__decorate([Prop({
  default: ''
})], AccountCreationNotificationDialog.prototype, "passwordUrl", void 0);
AccountCreationNotificationDialog = __decorate([Options({
  watch: {
    toggleDialog() {
      this.visible = this.toggleDialog;
    }
  }
})], AccountCreationNotificationDialog);
export default AccountCreationNotificationDialog;